import UpcomingProxyBid from '../models/UpcomingProxyBid';

export enum OdometerType {
  Kilometre = 0,
  Miles = 1
}

export enum OdometerTypeLabel {
  Kilometre = 'km',
  Miles = 'mi'
}

export enum TransmissionType {
  Automatic = 0,
  Manual = 1
}

export enum TransmissionTypeLabel {
  Automatic = 'Auto',
  Manual = 'Manual'
}

export enum DisclosureValue {
  Present = 1,
  Empty = -1
}

export interface ITradeDetails {
  cylinders: string;
  dateAvailable: string;
  decodedAt: string;
  disclosures: Array<any>;
  displacement: string;
  driveTrain: string;
  exteriorColor: string;
  fuelType: string;
  id: number;
  interiorColor: string;
  isAsIs: boolean;
  isImpounded: boolean;
  isLanded: boolean;
  isLoading: boolean;
  isMscCertified: boolean;
  isWatchlisted: boolean;
  manufacturerName: string;
  maxBid: number;
  modelName: string;
  notes: string;
  numberOfBids: number;
  odometerDisplay: string;
  options: Array<any>;
  passengers: number;
  pickupAddress: object;
  tags: Array<any>;
  titleInHand: boolean;
  tradeFloorPrice: object;
  tradeInCustomerInfo: object;
  transmission: string;
  transmissionDriveTrain: string;
  trim: string;
  upcomingProxyBid: UpcomingProxyBid;
  vehicleHistoryReportUrl: string;
  vin: string; // TODO specify a vin type
  year: number;
}

export const disclosuresType = {
  type: {
    integer: 0,
    bool: 1
  }
} as const;

export enum TradeState {
  upcoming = 1000,
  parked = 0,
  active = 1,
  lost = 2,
  arrived = 3,
  won = 4,
  delivered = 5,
  closing = 6,
  pending = 7,
  buynow = 11,
  purchase = 12
}

export enum TradeStateNew {
  ALL = 'All',
  PARKED = 0,
  ACTIVE = 1,
  LOST = 2,
  ARRIVED = 3,
  WON = 4,
  DELIVERED = 5,
  CLOSING = 6,
  PENDING = 7,
  ORPHANED = 8,
  CONSIGNED = 9,
  UPCOMING = 10,
  BUYNOW = 11
}

export const TR5TradeStates: Array<string> = ['Upcoming', 'Active'];

export const TradeStateNewName = {
  [TradeStateNew.PARKED]: 'Parked',
  [TradeStateNew.ACTIVE]: 'Active',
  [TradeStateNew.LOST]: 'Lost',
  [TradeStateNew.ARRIVED]: 'Arrived',
  [TradeStateNew.WON]: 'Won',
  [TradeStateNew.DELIVERED]: 'Delivered',
  [TradeStateNew.CLOSING]: 'Closing',
  [TradeStateNew.PENDING]: 'Pending',
  [TradeStateNew.ORPHANED]: 'Orphaned',
  [TradeStateNew.CONSIGNED]: 'Consigned',
  [TradeStateNew.UPCOMING]: 'Upcoming',
  [TradeStateNew.BUYNOW]: 'Buy Now'
};

export enum context {
  home = 'home',
  buying = 1,
  selling = 2,
  research = 3,
  create = 4
}

export const TradeStateName = {
  [TradeState.upcoming]: 'Upcoming',
  [TradeState.active]: 'Active',
  [TradeState.lost]: 'Lost',
  [TradeState.pending]: 'Pending',
  [TradeState.closing]: 'Closing',
  [TradeState.won]: 'Won',
  [TradeState.arrived]: 'Arrived',
  [TradeState.delivered]: 'Delivered',
  [TradeState.buynow]: 'Lost',
  [TradeState.purchase]: 'Purchase'
};

export const TradeStateEnumMap = {};
Object.keys(TradeStateName).map(key => {
  TradeStateEnumMap[TradeStateName[key].toLowerCase()] = parseInt(key, 10);
  return key;
});

export enum TradeContext {
  Buy = 1,
  Sell = 2
}

export const TradeContextName = {
  [TradeContext.Buy]: 'Buy',
  [TradeContext.Sell]: 'Sell'
};

// "/buying/active" -> TradeContext.Buy. additional "buy" "sell" to be more forgiving.
export const TradeContextEnum = {
  buying: TradeContext.Buy,
  selling: TradeContext.Sell,
  buy: TradeContext.Buy,
  sell: TradeContext.Sell
};

export const NeedMoreStatus = {
  status: {
    NotStarted: 0,
    NoActionRequired: 1,
    ActionRequired: 2,
    Rejected: 3,
    Accepted: 4,
    InProgress: 5,
    Inapplicable: 6
  },
  negotiationPosition: {
    None: 0,
    Seller: 1,
    Buyer: 2,
    SecondBuyer: 3 // Not in API yet
  }
};

export const TradePaginationConfig = {
  maxPerPage: 50
};

export const FilterNames = {
  all: {
    type: 0,
    id: 'all',
    title: 'Show all vehicles'
  },
  watchlist: {
    type: 1,
    id: 'watchlist',
    title: 'Watched vehicles'
  },
  impound: {
    type: 2,
    id: 'impound',
    title: 'Impounded vehicles'
  },
  franchise: {
    type: 7,
    id: 'franchise',
    title: 'Franchise list'
  },
  independent: {
    type: 8,
    id: 'independent',
    title: 'Independent lists'
  },
  default: {
    type: 10,
    id: 'default',
    title: 'Former default filter'
  },
  custom: {
    type: 5
  }
};

export const NetworkTypes = {
  sellerNetwork: {
    type: 5
  },
  buyerNetwork: {
    type: 9
  }
};

export enum ListVariant {
  LIST = 'list',
  GRID = 'grid',
  SEARCH = 'search',
  LOADING = 'loading',
  PAYMENTS_ON_HOLD = 'payments_on_hold_list'
}

export enum TradeViewVariant {
  LIST = 'list',
  VDP = 'vdp',
  BID_MODAL = 'bidModal',
  OMP_LIST = 'ompList'
}

export enum SaleEventHeaderVariant {
  COMPLETE = 'header-complete',
  CONTINUED = 'header-continued'
}

export enum SaleEventFooterVariant {
  COMPLETE = 'footer-complete',
  CONTINUED = 'footer-continued'
}

export enum GridCardVariant {
  EVENT_TRADE = 'eventTrade',
  NON_EVENT_TRADE = 'nonEventTrade',
  EVENT_START = 'eventStart',
  EVENT_END = 'eventEnd'
}

export enum TutorialModalVariant {
  SELLER_START_NEGO = 'sellerStartNego',
  SELLER_START_NEGO_OPEN = 'sellerStartNegoOPEN',
  SELLER_START_NEGO_DGN = 'sellerStartNegoDGN',
  SELLER_FIRST_REPLY = 'sellerFirstReply',
  SELLER_FIRST_REPLY_DGN = 'sellerFirstReplyDGN',
  BUYER_START_NEGO = 'buyerStartNego',
  BUYER_FIRST_REPLY = 'buyerFirstReply',
  SECOND_BIDDER_FINISH_NEGOTIATION = 'secondBidderFinishNegotiation'
}

export enum GridCardPosition {
  LEFT = 'left',
  BETWEEN = 'between',
  RIGHT = 'right'
}

// Uses remainder of (card position)/(row width) to decide the position of the card
export const GridCardPositionMapping = {
  1: GridCardPosition.LEFT,
  2: GridCardPosition.BETWEEN,
  3: GridCardPosition.BETWEEN,
  0: GridCardPosition.RIGHT
};

export enum GridRowSize {
  SMALL = 3,
  LARGE = 4
}

export enum CardType {
  PLAIN = 'plain'
}

export enum AuctionTimerType {
  ACTIVE = 'active',
  PENDING = 'pending',
  CLOSING = 'closing'
}

export enum TimerVariant {
  ALERT = 'alert',
  BOLD = 'bold',
  WARN = 'warn'
}

export enum NetworkVariant {
  ACTIVE = 'active',
  PENDING = 'pending'
}

export enum AllowedStateChangeProperties {
  // xxx->upcoming
  LAUNCH_DATE = 'launchDate',
  // xxx->active
  GAP = 'gap',
  PICKUP_ADDRESS_ID = 'pickupAddressId',
  TARGET_PRICE = 'targetPrice',
  BUYNOW_PRICE = 'buyNowPrice',
  BUYNOW_NETWORK_ID = 'buyNowNetworkId',
  // xxx->closing
  IS_FORCED_WON = 'isForcedWon',
  ACV = 'ACV',
  // won->arrived
  SALES_PRICE = 'salesPrice',
  KILOMETERS = 'kilometers',
  // xxx->delivered
  SOLD_PRICE = 'soldPrice',
  BUYER_RATING = 'buyerRating',
  SELLER_COMMENT = 'sellerComment',
  IS_VIN_VERIFIED = 'isVINVerified',
  // Generic
  SELLING_NETWORK_ID = 'sellingNetworkId',
  FLOOR_PRICE = 'floorPrice',
  IS_LANDED = 'isLanded',
  DATE_AVAILABLE = 'dateAvailable'
}

export enum BidPlaceErrorCode {
  COLLISION = 9125,
  OUTBID_DEALERSHIP = 9915,
  OUTBID_DGN = 9916,
  UNAUTHORIZED = 9113,
  TOO_LOW = 9104,
  PROXY_TOO_LOW = 9136,
  INVALID_AMOUNT = 9133,
  AMOUNT_SAME_AS_PROXY = 9135
}

export const FetchAuctionErrorCodes = [
  BidPlaceErrorCode.TOO_LOW,
  BidPlaceErrorCode.COLLISION,
  BidPlaceErrorCode.AMOUNT_SAME_AS_PROXY,
  BidPlaceErrorCode.PROXY_TOO_LOW
];
